// https://www.dbos.dev/jobs/keep-me-in-mind

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaStartBuildingForFree, FooterLinksFollowOurGithub2 } from '@components/layout/FooterCtas';
import { ScriptEmbed } from '@components/webflow';

export function JobsKeepMeInMindPage() {
  return (
    <SiteLayout
      banner={false}
      footerCta={
        <>
          <FooterCtaStartBuildingForFree />
          <FooterLinksFollowOurGithub2 />
        </>
      }
    >
      <div className="w-layout-vflex job-title-wrapper">
        <a href="/jobs" className="insights-breadcrumb w-inline-block">
          <div className="w-embed">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              {'\n'}
              <path
                d="M8.72266 15.1787L2.24958 8.99986L8.72266 2.82102"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              {'\n'}
              <path
                d="M2.25 9L15.75 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              {'\n'}
            </svg>
          </div>
          <div className="text-link-breadcrumb">Back to jobs</div>
        </a>
        <h1 className="text-heading-h2">Don't see an open position you'd like to fill?</h1>
      </div>
      <section className="job-wrapper">
        <div className="job-content-left">
          <div className="spacer-400" />
          <div className="button-primary-border">
            <a href="#apply" className="button-cta button-primary button-navigation w-inline-block">
              <div className="text-block">Apply for this role</div>
            </a>
          </div>
          <div className="spacer-400" />
          <div className="spacer-400" />
          <div className="w-layout-vflex job-meta">
            <div className="text-body-highlight">Location</div>
            <div className="text-body">United States, Remote</div>
          </div>
          <div className="w-layout-vflex job-meta">
            <div className="text-body-highlight">Type</div>
            <div className="text-body">Full-time</div>
          </div>
          <div className="w-layout-vflex job-meta">
            <div className="text-body-highlight">Team</div>
            <div className="text-body">DBOS</div>
          </div>
        </div>
        <div className="job-content-right">
          <div className="text-body-rich w-richtext">
            <p>Please submit your resume and tell us about your dream role at DBOS!</p>
            <p>{'If we start hiring for that role in the future, we will reach out to you. '}</p>
            <p>
              {'Some of the technologies we use at DBOS\u00a0include Python, TypeScript, Go, Java, PostgreSQL, AWS.'}
            </p>
            <p>We are a fully distributed team, with most of us located in the US.</p>
            <p>{'We look forward to hearing from you! '}</p>
            <p>{'\u200d'}</p>
          </div>
          <div id="apply" className="job-apply">
            <h2 className="text-heading-h3">Apply for this role</h2>
            <ScriptEmbed
              className="embedded-form w-embed w-script"
              html={
                '<script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>\n<script>\n  hbspt.forms.create({\n    region: "na1",\n    portalId: "45237820",\n    formId: "716526c6-245f-40d0-ac39-a81a606fb800"\n  });\n</script>'
              }
            />
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
